module.exports = __webpack_public_path__ + "assets/icon-cancel-delete.264d7fc4.svg";